import React, { forwardRef } from "react";
import { Input, InputGroup } from "rsuite";
import {DuskDawnHandle} from "../../menu/PrimaryClock/PrimaryClock.model";
import {DuskDawnTimeControlProps} from "./DuskDawnTimeControl.model";
const DuskDawnTimeControl = forwardRef<DuskDawnHandle, DuskDawnTimeControlProps>(
  ({ dawnTime, duskTime }, _ref) => {
    return (
      <div className="row">
        <div className="col-md-6">
          <InputGroup style={{ marginBottom: "5px", width: "100%" }}>
            <InputGroup.Addon>Восход</InputGroup.Addon>
            <Input className="bg-violet" value={dawnTime ?? ""} readOnly />
          </InputGroup>
        </div>
        <div className="col-md-6">
          <InputGroup style={{ marginBottom: "5px", width: "100%" }}>
            <InputGroup.Addon>Закат</InputGroup.Addon>
            <Input className="bg-violet" value={duskTime ?? ""} readOnly />
          </InputGroup>
        </div>
      </div>
    );
  }
);

DuskDawnTimeControl.displayName = "DuskDawnTimeControl";

export default DuskDawnTimeControl;
